import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import config from 'utils/config';
import createLocation from 'utils/createLocation';
import useBreakpoints from 'hooks/useBreakpoints';
import Arrow from 'components/Arrow';
import Box from 'components/Box';
import Button from 'components/Button';
import IconDisc from 'components/IconDisc';
import { SearchWidgetCard } from './SearchWidgetCard';

/**
 * Hook for fetching an AI summary of the top search result
 */

export function useTopResultSummary(searchTerm) {
  var _useQuery = useQuery({
      queryKey: ['searchAI', searchTerm],
      queryFn: function () {
        var _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var response;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("/api/ai/searchassistant?query=".concat(encodeURIComponent(searchTerm)));
              case 2:
                response = _context.sent;
                return _context.abrupt("return", response.json());
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function queryFn() {
          return _queryFn.apply(this, arguments);
        }
        return queryFn;
      }(),
      enabled: !!searchTerm && config.searchWithinContent && config.searchAIAssistant,
      // We don't want to regenerate a new summary if there's one already
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false
    }),
    data = _useQuery.data,
    queryState = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    summary: data === null || data === void 0 ? void 0 : data.answer
  }, queryState);
}
export function TopResultSummaryWidget(_ref) {
  var summary = _ref.summary,
    assetId = _ref.assetId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var _useBreakpoints = useBreakpoints(),
    isDesktop = _useBreakpoints.s;
  return /*#__PURE__*/React.createElement(SearchWidgetCard, {
    icon: /*#__PURE__*/React.createElement(IconDisc, {
      shady: true,
      name: "sparkles"
    }),
    title: t('search_top_result_summary'),
    arrowSlot: isDesktop && /*#__PURE__*/React.createElement(Arrow, {
      placement: "right-start",
      size: 10,
      distanceFromEdge: 14
    })
  }, /*#__PURE__*/React.createElement(Box, {
    as: "p",
    fontSize: "s",
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, summary), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    size: "medium",
    as: Link,
    isDisabled: !assetId,
    to: createLocation(location, {
      asset: assetId
    })
  }, t('actions_open')));
}